import { SerialNumberLocator, SubEntityType } from '../../models';
import { knowledgeBaseHttp } from '../knowledge-base-api';

export const getSerialNumberLocators = async (
  groupId: number,
  locale: string
): Promise<SerialNumberLocator[]> => {
  try {
    const url = `/group/${groupId}/${SubEntityType.SerialNumberLocators}?marketLocale=${encodeURIComponent(locale)}`;
    const response = await knowledgeBaseHttp.get<SerialNumberLocator[]>(url);

    return response?.data ?? [];
  } catch (error) {
    console.error(`Error fetching serial number locators:`, error);
    return [];
  }
};
